// 生产环境懒加载
module.exports = component => () => import('../views/' + component + '.vue')
